import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./utils/theme";
import { AuthProvider } from "./provider/AuthProvider";
import { CrumbProvider } from "./provider/CrumbProvider";
import "./utils/styles.css";
import { ScrollProvider } from "./provider/ScrollProvider";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store/store";
import { PersistGate } from "redux-persist/integration/react";
import RoutesWrapper from "./routes/RoutesWrapper";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ChakraProvider theme={theme}>
          <CrumbProvider>
            <AuthProvider>
              <ScrollProvider>
                <RoutesWrapper />
              </ScrollProvider>
            </AuthProvider>
          </CrumbProvider>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
